import type { Chain } from 'viem';
import type { Config } from 'wagmi';

import type { WalletAdapterData } from '../types';

import { connectToAdapter } from './connect-to-adapter';

export const connectEagerly = async (
  config: Config,
  adapters: WalletAdapterData[],
  supportedChains: [Chain, ...Chain[]],
) => {
  for (const adapter of adapters) {
    if (!adapter.detector?.()) {
      // eslint-disable-next-line no-continue
      continue;
    }

    try {
      const connector = adapter.getConnector();
      // eslint-disable-next-line no-await-in-loop
      const res = await connectToAdapter(config, connector, supportedChains);

      return res;
    } catch (e) {
      return null;
    }
  }

  return null;
};
